import { Component, Input, OnInit } from '@angular/core';
import { DeviceStatusService } from '../shared/services/device-status.service';
import { ToastService } from '@captiveaire/toast';
import { StateService } from '@uirouter/core';

@Component({
    selector: 'dl-device-json-viewer',
    templateUrl: './device-json-viewer.component.html',
    styleUrls: ['./device-json-viewer.component.scss']
})
export class DeviceJsonViewerComponent implements OnInit {
    public static $name: string = 'deviceJsonViewer';

    @Input() hardwareItemId: number;
    @Input() category: string;

    isReady = false;
    json: JSON;
    depth = 1;
    expanded = false;

    constructor(private deviceStatusService: DeviceStatusService,
                private toastService: ToastService,
                private stateService: StateService) {
    }

    ngOnInit() {
        this.getParametersFromUrl();
        this.loadJson();
    }

    expandAllClicked() {
        this.expanded = !this.expanded;
        this.depth = 99;
    }

    loadJson() {
        if (this.hardwareItemId && this.category) {
            this.deviceStatusService.getDeviceJson(this.hardwareItemId, this.category).then((data) => {
                try {
                    this.json = DeviceJsonViewerComponent.fromJson(data);
                    this.isReady = true;
                } catch (ex) {
                    this.json = DeviceJsonViewerComponent.fromJson('{}');
                    this.isReady = true;
                }
            }).catch(this.toastService.errorResponse);
        }
    }

    private static fromJson(data: string) {
        return typeof data === 'string' ? JSON.parse(data) : data;
    }

    private getParametersFromUrl() {
        const stateParams = this.stateService.params;
        this.hardwareItemId = parseInt(stateParams.hardwareItemId, 10);
        this.category = stateParams.category;
    }
}
